import {
  API_ROUTES,
  API_ROUTE_V2_PREFIX,
  IPageRequestParams,
  resolveCmpForApiRequest,
} from "@tm/api-utils";
import { LOB } from "@tm/isomorphic-utils";
import { getLobOnServerSide } from "@tm/server-utils";
import { API_HTTP } from "../apiInstance";
import { setURLQueryParams } from "../setURLQueryParams";

export const getCommonLandingPageDetails = async (
  reqData: IPageRequestParams & { isMobileDevice?: boolean }
) => {
  const { partner, headers, cmp, query, dvid, isMobileDevice } = reqData;
  const headerCmp = resolveCmpForApiRequest(cmp, query);

  const params = {
    lob: getLobOnServerSide(partner) || LOB.STANDALONE,
    authV2: "true",
    ...query,
  };

  const urlParams = setURLQueryParams(params);

  let url = `${API_ROUTE_V2_PREFIX}/${partner}/${
    API_ROUTES.GET_ENTRYPOINT_LANDING_PAGE_DATA
  }${urlParams ? `?${urlParams}` : ""}`;

  if (isMobileDevice) {
    url = `${API_ROUTE_V2_PREFIX}/mmt/${
      API_ROUTES.GET_COMMON_LANDING_PAGE_DETAILS
    }${urlParams ? `?${urlParams}` : ""}`;
  }

  const response = await API_HTTP.get(url, {
    headers: { ...headers, cmp: headerCmp || "fallback", dvid },
  });
  return response;
};
